import React from 'react';
import CapLabel from '../CapLabel';
import './_index.scss';
import { FormattedMessageWrapper } from './utils';
import CapIcon from '../CapIcon';
import CapHeading from '../CapHeading';
import CapRow from '../CapRow';

export const DisabledHoverPopover = ({
  hoverHeadingLabel= '',
  hoverHeadingText= '',
  hoverDescriptionLabel = '',
  hoverDescriptionText,
  hoverCTADisplayLabel = '',
  hoverCTADisplayName,
  hoverCTAAction,
  title,
  redirectToLink,
  pushDataToGTM,
}) => {
  const handleCTAButtonClick = () => {
    redirectToLink({
      redirectionType: 'location',
      targetLocation: '_blank',
      url: hoverCTAAction,
    });
    pushDataToGTM('clickDisabledHoverCTAButton', {
      redirectionType: 'location',
      targetLocation: '_blank',
      url: hoverCTAAction,
      title,
    });
  };
  return (
    <div  
    onClick={(e)=>{
      e.stopPropagation();
      hoverCTAAction && handleCTAButtonClick()
    }}>
    <div className="disabled-hover-popover-container">
      {(hoverHeadingLabel || hoverHeadingText) && (
        <CapHeading type="h9">
          <FormattedMessageWrapper id={hoverHeadingLabel} message={hoverHeadingText} />
        </CapHeading>
      )}
      {(hoverDescriptionLabel || hoverDescriptionText) && (
        <CapLabel type="label10" className='disable-hover-description'>
          <FormattedMessageWrapper id={hoverDescriptionLabel} message={hoverDescriptionText} />
        </CapLabel>
      )}
      {((hoverCTADisplayLabel || hoverCTADisplayName) && hoverCTAAction) && (
        <CapRow className="disable-hover-cta" onClick={handleCTAButtonClick}>
          <CapIcon type="open-in-new-light" />
          <CapLabel type="label27">
            <FormattedMessageWrapper id={hoverCTADisplayLabel} message={hoverCTADisplayName} />
          </CapLabel>
        </CapRow>
      )}
    </div>
    </div>
  );
};

DisabledHoverPopover.defaultProps = {
  hoverHeadingLabel: '',
  hoverHeadingText: '',
  hoverDescriptionLabel: '',
  hoverDescriptionText: '',
  hoverCTADisplayLabel: '',
  hoverCTADisplayName: '',
  hoverCTAAction: '',
  title: '',
  redirectToLink: () => {},
  pushDataToGTM: () => {},
};
export default DisabledHoverPopover;
